const hasValue = (state) => {
	if (state) {
		return Boolean(state.value)
	}
	return false;
}
const returnValue = (state) => {
	return state.value
}

const validateEmail = (email) => {
	let pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return pattern.test(email);
}





const checkInput = (state, errorCallback) => {

	if (!state) return;
	const errors = {
		FullName: "יש למלא שם",
		Email: "יש למלא מייל תקין",
		Age: "יש למלא גיל",
		Gender: "יש לבחור מין",
		FamilyImage: "יש לבחור תמונה תקינה",
		PhoneNumber: "יש להזין מספר טלפון תקין",
		MyMoment: "יש למלא את הסיפור שלך",
	}


	if (!hasValue(state)) {
		errorCallback(state, errors[state.name]);
		if (state.name == "Terms") {
			alert("עליך לאשר את הסכמתך לתקנון על מנת להמשיך");
		}
		return false;
	}
	switch (state.name) {

		case "FullName":
			if (state.value.length < 2) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "Age":
			if (state.value.length < 1) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "Gender":
			if (state.value == -1) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "MyMoment":
			if (state.value.length < 3) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			if (state.value.length > 499) {
				alert('אסור להכניס יותר מ500 תווים');
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "PhoneNumber":
			if (state.value.length < 7 || state.value.length > 15) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "Email":
			if (!validateEmail(state.value)) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "Terms":
			if (state.value != 1) {
				alert("עליך לאשר את הסכמתך לתקנון על מנת להמשיך");
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "FamilyImage":
			if (!state.value) {
				this.setErrorMessage(state, errors[state.name]);
				return false;
			}
			break;
	}
	return true;
}

export {
	validateEmail,
	returnValue,
	hasValue,
	checkInput
	
}


// WEBPACK FOOTER //
// ./src/Components/Services/Validation.js